import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-grid-hyperlink-cell-renderer',
  imports: [],
  templateUrl: './ag-grid-hyperlink-cell-renderer.component.html',
  styleUrl: './ag-grid-hyperlink-cell-renderer.component.scss'
})
export class AgGridHyperLinkCellRendererComponent implements ICellRendererAngularComp {
  private params: any;
  displayValue: string = '';

  constructor(private router: Router) {}

  agInit(params: any): void {
    this.params = params;
    this.displayValue = params.value;
  }

  refresh(): boolean {
    return false;
  }

  navigate(): void {
    if (this.params.beforeNavigate) {
      this.params.beforeNavigate();
    }

    let route = this.params.route;
    const params = this.params.routeParams || {};
    const queryParams = this.params.queryParams || {};
    const state = this.params.state || null;

    // Replace all :param occurrences
    Object.keys(params).forEach(key => {
      route = route.replace(`:${key}`, params[key]);
    });

    const segments = route.split('/').filter(x => x);

    this.router.navigate(segments, { queryParams, state });
  }
}
